// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__dVFeS","content":"RecentSearches_content__dYFai"};